import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import LoadingScreen from "../../components/LoadingScreen";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserCircle,
  faSignOutAlt,
  faEllipsisV,
  faPlusCircle,
} from "@fortawesome/free-solid-svg-icons";
import SweetAlert from "react-bootstrap-sweetalert";
import moment from "moment";
require("moment/locale/id");

class AdminDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: [],
      token: localStorage.getItem("Authorization"),
      dataBrief: [],
      btypelist: [],
      briefname: "",
      btypeid: null,
      hasBrief: true,
      alert: null,
      messages: null,
      isReady: 0,
    };
    this.confirmLogout = this.confirmLogout.bind(this);
    this.showCreateForm = this.showCreateForm.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleCreateNewForm = this.handleCreateNewForm.bind(this);
    this.confirmDeleteBtype = this.confirmDeleteBtype.bind(this);
    this.handleDeleteBtype = this.handleDeleteBtype.bind(this);
    this.confirmDeleteBrief = this.confirmDeleteBrief.bind(this);
    this.handleDeleteBrief = this.handleDeleteBrief.bind(this);
    this.handleRenameBlabel = this.handleRenameBlabel.bind(this);
  }

  componentDidMount() {
    axios
      .get(`${window.localhost}/admincre/whois`, {
        headers: {
          Authorization: `Bearer ${this.state.token}`,
        },
      })
      .then((response) => {
        let msg = response.data.success;
        if (msg === true) {
          this.getBrief();
          let progress = this.state.isReady + 30;
          this.setState({
            user: response.data.user,
            isReady: progress,
          });
        } else {
          this.props.history.push("/admincre/login");
        }
      });
  }

  getBrief() {
    axios
      .get(`${window.localhost}/admincre/allbrief`, {
        headers: {
          Authorization: `Bearer ${this.state.token}`,
        },
      })
      .then((response) => {
        let msg = response.data.success;
        if (msg === true) {
          this.getBtype();
          let progress = this.state.isReady + 50;
          this.setState({
            dataBrief: response.data.brief,
            isReady: progress,
          });
          console.log(response.data.brief);
        }
        // console.log(this.state.dataBrief);
      });
  }

  getBtype() {
    axios
      .get(`${window.localhost}/customer/btype`, {
        headers: {
          Authorization: `Bearer ${this.state.token}`,
        },
      })
      .then((response) => {
        let msg = response.data.success;
        if (msg === true) {
          let progress = this.state.isReady + 20;
          this.setState({
            btypelist: response.data.btype,
            isReady: progress,
          });
        }
        // console.log(this.state.btypelist);
      });
  }

  showCreateForm() {
    const getAlert = () => (
      <SweetAlert
        showCloseButton
        showCancel
        confirmBtnText="Submit"
        cancelBtnText="Batal"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="secondary"
        title="Create New Form"
        onConfirm={() => this.handleCreateNewForm()}
        onCancel={() => this.hideAlert()}
        focusConfirmBtn
      >
        <div className="my-3 text-start">
          <label htmlFor={`newform`} className="form-label">
            Brief Form Name <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="form-control form-cream border-0"
            name="briefname"
            id={`newform`}
            aria-describedby="ansEdit"
            placeholder="Masukkan nama form brief"
            onChange={this.handleFieldChange}
            required
            autoComplete="off"
          />
        </div>
      </SweetAlert>
    );
    this.setState({
      alert: getAlert(),
    });
  }

  handleFieldChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  handleCreateNewForm() {
    const formData = new FormData();
    formData.append("label", this.state.briefname);
    axios
      .post(`${window.localhost}/admincre/btype/create`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        if (response.data.success === true) {
          this.props.history.push(`/admincre/edit/${response.data.btype.slug}`);
        }
      });
  }

  confirmDeleteBrief(answer, customerid, btypeid, briefid) {
    const getAlert = () => (
      <SweetAlert
        warning
        showCancel
        confirmBtnText="Hapus"
        cancelBtnText="Batal"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="secondary"
        title="Tunggu..."
        onConfirm={() => this.handleDeleteBrief(customerid, btypeid, briefid)}
        onCancel={() => this.hideAlert()}
        focusCancelBtn
      >
        Apakah Anda yakin ingin menghapus brief <strong>"{answer}"</strong>?
      </SweetAlert>
    );
    this.setState({
      alert: getAlert(),
    });
  }

  handleDeleteBrief(customerid, btypeid, briefid) {
    axios
      .delete(
        `${window.localhost}/admincre/brief/${customerid}/${btypeid}/${briefid}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
          },
        }
      )
      .then((res) => {
        if (res.data.success === true) {
          this.getBrief();
          this.hideAlert();
        }
      });
  }

  confirmDeleteBtype(btype, btypeid) {
    const getAlert = () => (
      <SweetAlert
        warning
        showCancel
        confirmBtnText="Hapus"
        cancelBtnText="Batal"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="secondary"
        title="Tunggu..."
        onConfirm={() => this.handleDeleteBtype(btypeid)}
        onCancel={() => this.hideAlert()}
        focusCancelBtn
      >
        Apakah Anda yakin ingin menghapus form <strong>{btype}</strong> ?
      </SweetAlert>
    );
    this.setState({
      alert: getAlert(),
    });
  }

  handleDeleteBtype(btypeid) {
    axios
      .delete(`${window.localhost}/admincre/delbtype/${btypeid}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((res) => {
        if (res.data.success === true) {
          this.handleDestroyQuestion(btypeid);
        }
      });
    this.hideAlert();
  }

  handleDestroyQuestion(btypeid) {
    axios
      .delete(`${window.localhost}/admincre/question/destroy/${btypeid}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((res) => {
        if (res.data.success === true) {
          this.handleDestroyAnswer(btypeid);
        }
      });
  }

  handleDestroyAnswer(btypeid) {
    axios
      .delete(`${window.localhost}/admincre/answer/destroy/${btypeid}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((res) => {
        if (res.data.success === true) {
          this.getBtype();
        }
      });
  }

  handleRenameBlabel(e) {
    e.preventDefault();

    const formData = new FormData();
    formData.append("id", this.state.btypeid);
    formData.append("label", this.state.briefname);
    axios
      .post(`${window.localhost}/admincre/blabel/update`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((res) => {
        if (res.data.success === true) {
          this.setState({
            btypeid: null,
            briefname: "",
          });
          this.getBtype();
        }
      });
  }

  confirmLogout() {
    const getAlert = () => (
      <SweetAlert
        warning
        showCancel
        confirmBtnText="Logout"
        cancelBtnText="Batal"
        confirmBtnBsStyle="default"
        cancelBtnBsStyle="danger"
        title="Tunggu..."
        onConfirm={() => this.handleLogout()}
        onCancel={() => this.hideAlert()}
        focusCancelBtn
      >
        Apakah Anda yakin ingin Logout?
      </SweetAlert>
    );
    this.setState({
      alert: getAlert(),
    });
  }

  handleLogout() {
    axios
      .get(`${window.localhost}/admincre/logout`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        var msg = response.data.success;
        if (msg === true) {
          this.props.history.push("/admincre/login");
        }
      });
  }

  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  render() {
    const { user } = this.state;

    if (this.state.isReady < 100) {
      return <LoadingScreen />;
    } else {
      const { dataBrief, btypelist } = this.state;
      const navmenu = () => {
        return (
          <div className="d-flex">
            <a
              href="https://drive.google.com/drive/folders/1_PDrslretO5dZOADTubr65CkQLf9EcTN?usp=sharing"
              className="nav-link text-danger text-decoration-none my-auto fw-bold d-none d-md-flex"
              target="_blank"
              rel="noreferrer"
            >
              Tutorial
            </a>
            <div className="dropdown">
              <button
                className="btn text-danger d-flex align-items-center dropdown-toggle"
                aria-current="page"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="me-2 d-md-flex d-none">{user.username}</span>
                <FontAwesomeIcon icon={faUserCircle} className="fs-3" />
              </button>
              <ul
                className="dropdown-menu dropdown-menu-end"
                aria-labelledby="dropdownMenuButton1"
              >
                <li>
                  <button
                    className="dropdown-item"
                    onClick={this.confirmLogout}
                  >
                    <FontAwesomeIcon icon={faSignOutAlt} /> Logout
                  </button>
                </li>
              </ul>
            </div>
          </div>
        );
      };

      return (
        <div>
          <Helmet>
            <meta charSet="utf-8" />
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1"
            />
            <title>Admin Dashboard - Creatifa Brief App</title>
            <meta
              name="description"
              content="Brief ini untuk membantu kami dalam membuat desain logo Anda. Mohon luangkan waktu untuk mengisi dengan jawaban se-objektif mungkin. Semakin Anda menuliskan gambaran usaha Anda dengan jelas, semakin kami dapat memahami desain logo seperti apa yang Anda butuhkan"
            />
          </Helmet>
          <Header menu={navmenu()} destination={`/admincre`} />
          <div className="container wrapper-sm wrapper">
            <div className="card container p-3 mb-4">
              {this.state.hasBrief ? (
                <div className="table-responsive">
                  <h2 className="text-center">
                    <span className="cf-header fw-bold px-2">
                      Client Brief List
                    </span>
                  </h2>
                  <hr />
                  <table className="table table-hover">
                    <thead>
                      <tr className="bg-dark text-light border border-1">
                        <th scope="col" className="text-center">
                          Jenis
                        </th>
                        <th scope="col" className="ps-3">
                          Institusi
                        </th>
                        <th scope="col" className="ps-3">
                          Nama
                        </th>
                        <th scope="col">Tanggal Kirim</th>
                        <th scope="col" className="ps-3"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {dataBrief.map((data, i) => (
                        <tr key={i} className="border-1">
                          <td
                            className={`align-middle text-white fw-bold text-center bg-red`}
                          >
                            {data.btype.label.toUpperCase()}
                          </td>
                          <td className={`align-middle ps-3 fw-bold`}>
                            {data.customer.institusi.toUpperCase()}
                          </td>
                          <td className="align-middle ps-3 fw-bold">
                            {data.btype.label !== "logo"
                              ? `${data.answer.substr(0, 20)}...`
                              : data.answer}
                            {moment(data.created_at).isSame(moment(), "day") ? (
                              <span className="badge rounded-pill bg-warning text-dark">
                                New
                              </span>
                            ) : (
                              ""
                            )}
                          </td>
                          <td className="align-middle fw-bold">
                            {moment(
                              data.created_at,
                              "YYYY-MM-DD hh:mm:ss"
                            ).format("DD MMMM YYYY")}
                          </td>
                          <td className="align-middle">
                            <div className="dropstart">
                              <button
                                className="btn btn-light border-1 float-end shadow-sm"
                                type="button"
                                id="dropdownMenuButton1"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <FontAwesomeIcon icon={faEllipsisV} />
                              </button>
                              <ul
                                className="dropdown-menu dropdown-menu-end"
                                aria-labelledby="dropdownMenuButton1"
                              >
                                <li>
                                  <Link
                                    className="dropdown-item"
                                    to={`/admincre/view/${data.customer_id}/${data.btype.slug}/${data.brief_id}`}
                                  >
                                    View
                                  </Link>
                                </li>
                                <li>
                                  <button
                                    className="dropdown-item"
                                    onClick={() =>
                                      this.confirmDeleteBrief(
                                        data.answer,
                                        data.customer_id,
                                        data.btype_id,
                                        data.brief_id
                                      )
                                    }
                                  >
                                    Delete
                                  </button>
                                </li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="row">
                  <p>Anda belum membuat brief.</p>
                </div>
              )}
            </div>

            <div className="card container p-3 mb-4">
              <div className="row text-center">
                <h2>
                  <span className="cf-header fw-bold px-2">Form Brief</span>
                </h2>
              </div>

              <hr />

              <div className="row mb-3">
                <div className="col">
                  <button
                    type="button"
                    className="btn btn-red text-white rounded-pill float-end px-4"
                    onClick={this.showCreateForm}
                  >
                    <FontAwesomeIcon icon={faPlusCircle} /> Create New Form
                  </button>
                </div>
              </div>

              <div className="row row-cols-md-2 row-cols-1">
                {btypelist.map((btype, i) => (
                  <div key={i} className="col mb-3">
                    <div className="card rounded-pill shadow-sm">
                      <div className="card-body d-flex justify-content-between">
                        <div>
                          {this.state.btypeid === btype.id ? (
                            <div>
                              <form onSubmit={this.handleRenameBlabel}>
                                <div className="d-flex px-3">
                                  <input
                                    type="text"
                                    className="form-control form-cream rounded-pill border-0"
                                    name="briefname"
                                    id={`renameform`}
                                    aria-describedby="formRename"
                                    placeholder="Masukkan nama form brief"
                                    onChange={this.handleFieldChange}
                                    value={this.state.briefname}
                                    required
                                    autoComplete="off"
                                  />
                                  <button
                                    type="button"
                                    onClick={() =>
                                      this.setState({
                                        btypeid: null,
                                        briefname: "",
                                      })
                                    }
                                    className="btn btn-secondary rounded-pill px-3 ms-2"
                                  >
                                    Batal
                                  </button>
                                  <button
                                    type="submit"
                                    className="btn btn-red text-white rounded-pill px-3 ms-2"
                                  >
                                    Simpan
                                  </button>
                                </div>
                              </form>
                            </div>
                          ) : (
                            <span className="badge rounded-pill fs-5 text-dark">
                              {btype.label.toUpperCase()}{" "}
                              <span
                                className={`badge ms-3 ${
                                  btype.status === "published"
                                    ? "bg-red"
                                    : "bg-yellow text-dark"
                                }`}
                              >
                                {btype.status.toUpperCase()}
                              </span>
                            </span>
                          )}
                        </div>
                        <div className="dropstart">
                          <button
                            className="btn btn-light border-1 float-end shadow-sm"
                            type="button"
                            id="dropdownMenuButton1"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <FontAwesomeIcon icon={faEllipsisV} />
                          </button>
                          <ul
                            className="dropdown-menu dropdown-menu-end"
                            aria-labelledby="dropdownMenuButton1"
                          >
                            <li>
                              <button
                                className="dropdown-item"
                                onClick={() =>
                                  this.setState({
                                    btypeid: btype.id,
                                    briefname: btype.label,
                                  })
                                }
                              >
                                Rename
                              </button>
                            </li>
                            <li>
                              <Link
                                to={`/admincre/edit/${btype.slug}`}
                                className="dropdown-item"
                              >
                                Edit
                              </Link>
                            </li>
                            <li>
                              <button
                                className="dropdown-item"
                                onClick={() =>
                                  this.confirmDeleteBtype(btype.label, btype.id)
                                }
                              >
                                Delete
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <Footer />
          {this.state.alert}
        </div>
      );
    }
  }
}

export default AdminDashboard;
